/*LIBRARY*/
import { Reorder, useDragControls } from "framer-motion";

/*COMPONENT*/
import UploadPictureField from "../../Components/form/UploadPictureField";
import InputDummy from "./InputDummy";
import AddButtonBetweenList from "../../Components/form/AddButtonBetweenList";

/*REDUX*/

/*PICTURE*/
import icon_reorder from "../../Assets/svg/icon_reorder.svg";
import icon_delete_2 from "../../Assets/svg/icon_delete_2.svg";
import icon_delete_image from "../../Assets/svg/icon_delete_image.svg";
import icon_edit_text from "../../Assets/svg/icon_edit_text.svg";
import icon_hamburger from "../../Assets/svg/icon_hamburger.svg";

/*FUNCTION*/

/*DATA*/
import { data_types } from "../../App/validation/data_types";
import dict from "../../Data/dict.json";

/*CONST*/

const FieldCard = ({
  idx,
  field_element,
  fields,
  field,
  from_uuid,
  modal_reorder,
  language,
  setFromUuid,
  is_hold,
  dragControls,
  toggle_push_in_the_middle,
  toggle_is_hold,
  submit_reorder,
  toggle_reorder,
  toggle_term,
  toggle_sidebar,
  toggle_delete_field,
  toggle_push_field,
  submit_delete_picture_field,
}) => {
  const { type, uuid, name, description = "", formula } = field_element;

  const type_current = data_types(language).find(
    (type_element) => type_element.value === type,
  );

  const icon_type = type_current?.icon;
  const name_type = type_current?.name;

  const rumus = formula.map((f, index) => {
    if (f.type === "operator") {
      return (
        <p key={index} className="inline" style={{ color: "red" }}>
          {f.content}
        </p>
      );
    } else
      return (
        <p key={index} className="inline" style={{ color: "blue" }}>
          {f.content}
        </p>
      );
  });

  return (
    <Reorder.Item
      id={uuid}
      value={field_element}
      style={{
        listStyleType: "none",
      }}
      dragListener={false}
      dragControls={dragControls}
    >
      <AddButtonBetweenList
        idx={idx}
        field_element={field_element}
        toggle_push_in_the_middle={toggle_push_in_the_middle}
      />
      {field_element.picture_url && (
        <section
          className="container_icon"
          style={{
            backgroundColor: "#ffffff",
            marginBottom: "10px",
          }}
        >
          <img
            src={field_element.picture_url}
            alt="pertanyaan"
            style={{ width: "100%", height: "auto" }}
          />
        </section>
      )}

      {/* {type !== "section" ? ( */}
      <main
        className="two_container_small_right"
        style={{
          marginBottom: "10px",
        }}
      >
        <section
          className="container_flat"
          style={{
            display: "flex",
            gap: "30px",
            backgroundColor:
              field_element.uuid === field?.uuid ||
              (uuid === from_uuid && modal_reorder)
                ? "#c0e4ff"
                : "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRight: "2px solid #dedede",
            }}
          >
            <div
              style={{
                cursor: is_hold ? "grabbing" : "grab",
                marginRight: "10px",
              }}
              onPointerDown={(event) => {
                setFromUuid(uuid);
                toggle_is_hold(true);
                dragControls.start(event);
              }}
            >
              <img
                alt="draggable"
                draggable={false}
                src={icon_hamburger}
                style={{
                  width: 20,
                  height: 20,
                }}
              />
            </div>
          </div>

          <div>
            <div className="margin_bottom">
              {modal_reorder && uuid !== from_uuid ? (
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <img
                    style={{
                      cursor: "default",
                      marginRight: "5px",
                      width: "25px",
                    }}
                    src={icon_reorder}
                    alt="Reorder"
                  />
                  <div
                    className="button_small outline_grey button_white"
                    onClick={() => {
                      submit_reorder(uuid);
                    }}
                    style={{
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                  >
                    {dict["Switch to this"][language]}
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <img
                    onClick={() => {
                      toggle_reorder(uuid);
                    }}
                    style={{
                      cursor: "pointer",
                      marginRight: "5px",
                      width: "25px",
                    }}
                    src={icon_reorder}
                    alt="Reorder"
                  />
                  <div
                    className="button_small outline_grey button_white"
                    onClick={() => toggle_term(field_element)}
                    style={{
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                    title="Atur visibilitas pertanyaan di FORM MAPID"
                  >
                    {dict["Question Visibility"][language]}
                  </div>
                </div>
              )}
            </div>

            <p className="text_small sub_color margin_bottom">
              {dict["Question"][language]} {idx + 1}
            </p>

            <p className="text_bold margin_bottom">
              {name}{" "}
              <img
                onClick={() => toggle_sidebar(field_element)}
                style={{ cursor: "pointer" }}
                src={icon_edit_text}
                alt={type}
                width="15px"
                height="auto"
              />
            </p>

            {/* nampilin rumus */}
            {formula?.length > 0 &&
              field_element?.type === "math_operators" && (
                <div
                  style={{
                    border: "1px solid",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    width: "100%",
                  }}
                >
                  {rumus}
                </div>
              )}

            {/* Deskripsi pertanyaan */}
            <p
              className="text_medium"
              style={{
                fontSize: "16px",
                whiteSpace: "pre-wrap",
              }}
            >
              {description}
            </p>
            {/* dibuat {...field_element} supaya terupdate */}
            <InputDummy
              field_element={{ ...field_element }}
              fields={[...fields]}
              toggle_delete_field={toggle_delete_field}
              toggle_push_field={toggle_push_field}
              toggle_sidebar={toggle_sidebar}
              field_state={{ ...field }}
            />
          </div>
        </section>

        {/* ICON SAMPING KANAN */}
        <section>
          <button title={name_type} style={{ marginBottom: "10px" }}>
            <div
              onClick={() => toggle_sidebar(field_element)}
              className="container_icon"
              style={{
                backgroundColor:
                  field_element.uuid === field?.uuid ? "#c0e4ff" : "#fff",
                width: "20px",
              }}
            >
              <img
                src={icon_type}
                alt={type}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </button>
          <button
            title={dict["Delete"][language]}
            style={{ marginBottom: "10px" }}
          >
            <div
              onClick={() => toggle_delete_field(field_element)}
              className="container_icon"
              style={{
                cursor: "pointer",
                width: "20px",
                backgroundColor: "#fff",
              }}
            >
              <img
                src={icon_delete_2}
                alt={type}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </button>
          {/* GAMBAR PERTANYAAN */}
          {!field_element.picture_url ? (
            <UploadPictureField field_current={field_element} />
          ) : (
            <button
              title={dict["Delete Picture"][language]}
              style={{ marginBottom: "10px" }}
            >
              <div
                onClick={() => submit_delete_picture_field(field_element)}
                className="container_icon"
                style={{
                  cursor: "pointer",
                  width: "20px",
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src={icon_delete_image}
                  alt={type}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            </button>
          )}
        </section>
      </main>
    </Reorder.Item>
  );
};

function FieldCardParent(props) {
  const dragControls = useDragControls();

  return <FieldCard {...props} dragControls={dragControls} />;
}

export default FieldCardParent;
